
require.register("babel-runtime/core-js/promise.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "babel-runtime");
  (function() {
    module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
  })();
});